module.exports = __webpack_public_path__ + "static/media/exhibition.cfd16fed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/exhibition.jpg
// module id = 382
// module chunks = 4